import { Factory } from '../../services/Factory';

interface IReplacePdfControllerScope extends angular.IScope {
  project;
  resource;
  source;
  pdfReplace;
  closeModal: Function;
  startReplace: Function;
  saving: boolean;
}

export class ReplacePdfModalController {
  private $scope:IReplacePdfControllerScope;
  private $modalInstance;
  private $location;
  private $timeout;
  private project;
  private resource;

  private resourceService;
  private accountService;
  private notificationService;

  constructor($scope:IReplacePdfControllerScope, $modalInstance, $location, $timeout, project, resource, resourceService, accountService, notificationService) {
    this.$scope = $scope;
    this.$modalInstance = $modalInstance;
    this.$location = $location;
    this.$timeout = $timeout;
    this.project = project;
    this.resource = resource;
    this.accountService = accountService;
    this.resourceService = resourceService;
    this.notificationService = notificationService;

    this.$scope.closeModal = () => {
      this.$modalInstance.close();
    };

    this.$scope.pdfReplace = {
      file: null,
      isRedacted: false,
      progress: {
        uploadBytesLoaded: 0,
        uploadBytesTotal: 0,
        uploadProgress: 0
      }
    };

    this.$scope.source = {
      valid: ""
    };

    this.$scope.$on('fileDropped', (evt, file) => {
      evt.stopPropagation();
      evt.preventDefault();

      this.$scope.source.valid = "valid";
      this.$scope.pdfReplace.file = file;
    });

    this.$scope.$on('droppedFileRemoved', (evt) => {
      evt.stopPropagation();
      evt.preventDefault();

      this.$scope.source.valid = "";
      this.$scope.pdfReplace.file = null;
    });

    this.$scope.startReplace = () => {
      this.$scope.saving = true;

      resourceService.ReplacePdf(this.$scope.resource, this.$scope.pdfReplace.file, this.$scope.pdfReplace.isRedacted,
        (loaded, total, percent) => {
          $timeout(() => {
            $scope.$apply(() => {
              this.$scope.pdfReplace.progress.uploadBytesLoaded = loaded;
              this.$scope.pdfReplace.progress.uploadBytesTotal = total;
              this.$scope.pdfReplace.progress.uploadProgress = percent;
            });
          });
        },
        () => {
          $timeout(() => {
            $scope.$apply(() => {
              $scope.saving = false;
              $scope.closeModal();

              this.notificationService.addSuccess({
                title: 'Pdf replace started',
                description: '',
                timeout: 5000
              });
            });
          });

        }, () => {
          $timeout(() => {
            $scope.$apply(() => {
              $scope.saving = false;
              $scope.closeModal();

              this.notificationService.addError({
                title: 'Error replacing Pdf',
                description: "That's embarrassing, please try again later",
                timeout: 5000
              });
            });
          });
        }
      );

    };
  }
}

frontendApp.controller("ReplacePdfModalController", ["$scope", "$uibModalInstance", "$location", "$timeout", "project", "resource", "ResourceService", "AccountService", "NotificationService", Factory.Create(ReplacePdfModalController)]);